/** Merge identities before presentation filters, so a hidden direct row cannot
 * reappear through the offer layer. The direct row keeps its editing semantics. */
type ActivityIdentity={id:string;deal_id?:string|null;source_label?:string};
export function mergeActivitySources<T extends ActivityIdentity>(direct:readonly T[],related:readonly T[],showRelated:boolean):{direct:T[];related:T[]}{
 const directById=new Map<string,T>();for(const row of direct)if(!directById.has(row.id))directById.set(row.id,row);
 if(!showRelated)return {direct:[...directById.values()],related:[]};
 const relatedById=new Map<string,T>();for(const row of related)if(!relatedById.has(row.id))relatedById.set(row.id,row);
 return {
  direct:[...directById.values()].map(row=>{
   const offer=relatedById.get(row.id);
   return row.deal_id&&offer?.deal_id===row.deal_id&&offer.source_label?{...row,source_label:offer.source_label}:row;
  }),
  related:[...relatedById.values()].filter(row=>!directById.has(row.id))
 };
}
